import { ISortModel } from '@core/interfaces/ISortModel';

export default function encodeSortModel(sortModel: ISortModel[]) {
    if (sortModel && sortModel.length > 0) {
        const [{ field, sort }] = sortModel;
        return `${field}+${sort}`;
    } else return '';
}
